import { drawerWidth } from "@component/core/Drawer";
import { useMediaQuery } from "@mui/material";
export const desktopWidth = 600 + drawerWidth;
export const isDesktop = () => {
  return useMediaQuery(`(min-width:${desktopWidth}px)`);
};